/**
 * @file index.tsx
 *
 * @fileoverview Renders Resume Badges in teaser.
 */
import React from 'react';
import { ResumeBadge } from '~/jobiqo/models/resume_badge';
import FlexItems from '~/vcl/atoms/06-layout/03-flex';
import FlexItem from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Image } from '~/vcl/atoms/19-image';
import { FormattedMessage } from 'react-intl';
import Text from '~/vcl/atoms/13-text/03-text';
const MAX_BADGES_TO_SHOW = 3;

interface ResumeTeaserBadgesProps {
  /**
   * The resume badges to display.
   */
  badges: ResumeBadge[];
}

export function ResumeTeaserBadges({ badges }: ResumeTeaserBadgesProps) {
  const badgesToShow = badges.slice(0, MAX_BADGES_TO_SHOW);

  return (
    <FlexItems gap={4} alignItems="center" justifyContent="flex-end">
      {badgesToShow.map(
        (badge: ResumeBadge) =>
          badge.icon && (
            <FlexItem key={badge.id}>
              <Image
                src={badge.icon.url}
                alt={badge.icon.alt ?? badge.name ?? ''}
                width="48"
                height="48"
              />
            </FlexItem>
          ),
      )}
      {badges.length > MAX_BADGES_TO_SHOW && (
        <FlexItem>
          <Text tag="span">
            <FormattedMessage
              id="resume_teaser_badges_more"
              defaultMessage="+ {count} more"
              values={{ count: badges.length - MAX_BADGES_TO_SHOW }}
            />
          </Text>
        </FlexItem>
      )}
    </FlexItems>
  );
}

export default ResumeTeaserBadges;
